import dynamic from 'next/dynamic';
import { useContext } from 'react';
import MenuOptionLabel from '~/constants/srp/MenuOptionLabel';
import SearchContext from '~/context/srp/SearchContext';
import FilterDrawer from './FilterDrawer';

const Budget = dynamic(
  () => import(/* webpackChunkName: "BudgetFacet" */ './Budget'),
  { ssr: false }
);

export default function PaymentAndPrice() {
  const { expandOnOpen } = useContext(SearchContext);
  const expandSection = expandOnOpen === MenuOptionLabel.PricePayment;

  return (
    <FilterDrawer
      className="!px-0"
      testId="facet-payment-price"
      facetContent={2}
      facetName="Payment & Price"
      defaultExpanded={expandSection}
      alwaysRenderChildren={true}
    >
      <Budget />
    </FilterDrawer>
  );
}
